var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRotateRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.714 14.857A1.29 1.29 0 0038 13.571V3.286A1.29 1.29 0 0036.714 2a1.29 1.29 0 00-1.285 1.286v7.44C32.279 5.497 26.549 2 20 2 10.06 2 2 10.06 2 20s8.06 18 18 18c6.42 0 12.054-3.359 15.244-8.421.522-.836-.113-1.865-1.101-1.865-.482 0-.916.257-1.181.66-2.749 4.242-7.53 7.055-12.962 7.055-8.518 0-15.429-6.911-15.429-15.429S11.482 4.571 20 4.571c5.713 0 10.695 3.102 13.363 7.715H26.43a1.29 1.29 0 00-1.286 1.285 1.29 1.29 0 001.286 1.286h10.285z"
  })));
}
export default SvgArrowRotateRight;